























































































import { Vue, Component, Watch } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { NamedOnboarding as OnboardingRouteName } from "@/employee/route-names";
import { useFamilyStore } from "@/employee/store/family";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { lastFour as ssnLastFour } from "@/shared/ssn";
import { handleError as handleErrorHelper } from "@/shared/storeHelper";
import { FamilyMember, FetchState, familyMemberRelationshipMap } from "@/shared/types";

interface DependentTableItem {
  id: number;
  name: string;
  dateOfBirth: string;
  ssn: string;
  ssnLastFour: string;
  revealSsn: boolean;
  relationship: string;
}

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class ReviewDependents extends Vue {
  familyStore = useFamilyStore();

  dependents: DependentTableItem[] = [];

  get isLoaded () {
    return this.familyStore.fetchState === FetchState.Loaded;
  }

  get isFailed () {
    return this.familyStore.fetchState === FetchState.Failed;
  }

  @Watch("familyStore.family", { deep: true })
  onDependentsChanged () {
    this.initializeFromState();
  }

  mounted () {
    this.initializeFromState();
    this.familyStore.initialize().catch(this.handleFamilyError);
  }

  initializeFromState () {
    this.dependents = [];

    if (!this.familyStore.familyMembers) {
      return;
    }

    this.dependents = this.familyStore.familyMembers.map(this.mapDependentTableItem);
  }

  mapDependentTableItem (dependent: FamilyMember): DependentTableItem {
    return {
      id: dependent.id,
      name: dependent.fullName,
      dateOfBirth: formatMMddyyyyDateString(dependent.dateOfBirth),
      ssn: dependent.ssn,
      ssnLastFour: dependent.ssn ? ssnLastFour(dependent.ssn) : "",
      revealSsn: false,
      relationship: familyMemberRelationshipMap[dependent.relationship]
    };
  }

  goToStep (stepKey: string) {
    this.$router.push({ name: OnboardingRouteName, params: { stepKey } });
  }

  collapseId (id: number) {
    return `collapse-${id}`;
  }

  toggleDetails (id: any) {
    this.$root.$emit("bv::toggle::collapse", id);
    this.toggleCollapsedClass(id);
  }

  toggleCollapsedClass (id: any) {
    const elem = document.getElementById(id);
    if (elem.classList.contains("collapsed")) {
      elem.classList.remove("collapsed");
    } else {
      elem.classList.add("collapsed");
    }
  }

  toggleDependentSsnMask (dependent: DependentTableItem) {
    dependent.revealSsn = !dependent.revealSsn;
  }

  handleFamilyError (error: any) {
    this.familyStore.setFetchState(FetchState.Failed);
    return handleErrorHelper({ error, rethrow: false });
  }
}
